import React, { useCallback, useContext } from "react";
import { useSpring, animated as A } from "react-spring";
import * as Icons from "../../Icons";
import AccordionContext from "../context";
import * as S from "./styles";
export var Heading = function Heading(_ref) {
  var e = _ref.children,
      t = _ref.className,
      a = _ref.style,
      _ref$uid = _ref.uid,
      n = _ref$uid === void 0 ? "" : _ref$uid,
      o = _ref.hideCaret,
      c = _ref.dataTestId,
      r = _ref.onClick;

  var _useContext = useContext(AccordionContext),
      i = _useContext.openElement,
      s = _useContext.openedItems,
      d = useCallback(function () {
    return i(n);
  }, [i, n]),
      l = null == s ? void 0 : s.includes(n),
      m = useSpring({
    transform: "rotate(".concat(l ? 0 : 180, "deg)")
  });

  return React.createElement(S.Heading, {
    onClick: function onClick(e) {
      d(), r && r(e);
    },
    className: t,
    role: "button",
    "aria-expanded": l,
    "aria-controls": "child-".concat(n),
    id: "accordion-heading-".concat(n),
    tabIndex: 0,
    "data-testid": c || "accordion-heading-".concat(n),
    style: Object.assign({}, a)
  }, "function" == typeof e ? e(l) : e, !o && React.createElement(A.div, {
    style: m
  }, React.createElement(Icons.UpCaret, null)));
};
export default React.memo(Heading);